import { Box } from 'braid-design-system';
import { vars } from 'braid-design-system/css';

export const Table = ({ children }: { children: React.ReactNode }) => (
  <Box
    style={{
      overflowX: 'auto',
      scrollSnapType: 'x mandatory',
    }}
  >
    <Box
      borderRadius="large"
      component="table"
      width="full"
      cellSpacing={0}
      cellPadding={0}
      overflow="hidden"
      style={{
        borderCollapse: 'separate',
        border: `${vars.borderWidth.standard} solid ${vars.borderColor.neutralLight}`,
      }}
    >
      {children}
    </Box>
  </Box>
);
